export const FLASHCARD_BASE_WIDTH = 240
export const FLASHCARD_BASE_HEIGHT = 160
